// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"bdf0fee0","856":"7e37dc36","952":"2da87c94"}[chunkId] + ".chunk.js";
};